"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortFn = exports.SORT_ORDER = void 0;
var SORT_ORDER = exports.SORT_ORDER = {
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
  POPULARITY: 'Popularity'
};
var sortFn = exports.sortFn = function sortFn(arr, sortOrder) {
  return arr.sort(function (a, b) {
    if (sortOrder === SORT_ORDER.NEWEST) {
      return new Date(b.createdOn) - new Date(a.createdOn);
    }
    if (sortOrder === SORT_ORDER.OLDEST) {
      return new Date(a.createdOn) - new Date(b.createdOn);
    }
    if (sortOrder === SORT_ORDER.POPULARITY) {
      return b.likes.length - a.likes.length;
    }
  });
};